import { sprint1ParseInt } from "shared/parseInt";

export function getQueryStringValue(
  queryStringName: string
): string | undefined {
  const url = window.location.search;
  const params = new URLSearchParams(url);
  const newParams = new URLSearchParams();
  params.forEach((value, key) => {
    newParams.append(key.toLowerCase(), value);
  });

  const value = newParams.get(queryStringName.toLowerCase());
  return value ?? undefined;
}

export function getQueryStringValueWithType<T extends number | string>(
  queryStringName: string,
  type: "int" | "string" = "string"
): T | undefined {
  const qsValue = getQueryStringValue(queryStringName);
  if (qsValue !== null && qsValue !== undefined && type === "int") {
    return sprint1ParseInt(qsValue) as T;
  }
  return qsValue as T;
}
